<template>

<div class="mt-3">
        <div class="row">
            <div class="col-sm-4 modspec_font14">Roof</div>
        </div>
        <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <!------------------------------->
                <div class="row mt-2">
                    <div class="col-sm-4">
                        <select class="form-select">
                            <option value="">Select</option>
                            <option value="Pitched">Pitched</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">
                        Roof Sheeting/cladding:
                    </div>
                    <div class="col-sm-1 modspec_font10">Colour:</div>
                    <div class="col-sm-3">
                        <select class="form-select">
                            <option value="Light">Light</option>
                            <option value="Medium">Medium</option>
                            <option value="Dark">Dark</option>
                        </select>
                    </div>
                    <div class="col-sm-1 modspec_font10">Type</div>
                    <div class="col-sm-3">
                        <select class="form-select">
                            <option value="Tile">Tile</option>
                            <option value="Steel Sheet">Steel Sheet</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">
                        Roof Blanket:
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        <input class="form-check-input" id="roofDescription" type="checkbox"> <label
                            class="form-check-label modspec_font10" for="roofDescription"> Description</label>
                    </div>
                    <div class="col-sm-3">
                        <input type="text" class="form-control" placeholder="i.e Anticon" />
                    </div>
                    <div class="col-sm-1 modspec_font10">R-val</div>
                    <div class="col-sm-2">
                        <input type="number" class="form-control" value="1.0" step=".1" />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-8"></div>
                    <div class="col-sm-2 modspec_font10">
                        <label class="form-check-label modspec_font10" for="roofReflective">Reflective? </label> <input
                            class="form-check-input" id="roofReflective" type="checkbox">
                    </div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="">Facing</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-2 modspec_font14">Framing</div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="Metal">Metal</option>
                            <option value="Timber">Timber</option>
                        </select>
                    </div>
                    <div class="col-sm-1 modspec_font10">Purlins:</div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="">LC15019</option>
                        </select>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2 modspec_font10">
                        Ctrs(mm)
                        <i style="position:absolute; margin-top:-5px;" @click="showInformation({title:'Information',body:'Approximate average spacing for this framing member'})"
                                class="bi bi bi-info-circle me-1 modspec_font8"></i>
                    </div>
                    <div class="col-sm-2">
                        <input type="text" class="form-control" placeholder="900" />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4">
                        <button class="btn btn-primary">Add Detail/Note +</button>
                    </div>
                </div>
                <!------------------------------->
            </div>
        </div>


    </div>
</template>
<script>
export default {
    name: "cd-roof",
    data: function () {
        return {
            roof: {  },
            //number:0
        }
    },
    mounted() {

    },
    methods: {
        test(){
            this.roof = {  };
        },

    },
}
</script>
<style></style>